export default __webpack_public_path__ + "static/media/viewliveimg.103f43bb.png";